import { LineChart } from '@/components/charts/LineChart';
import { Text } from '@/components/ui';

interface HoursChartProps {
  data?: { week: string; value: number }[];
  totalHours?: number;
}

export function HoursChart({ data, totalHours = 0 }: HoursChartProps) {
  return (
    <div className="bg-base-white border-transparent-dark-12 p-xs rounded-2xl border">
      <Text variant="label" strong>
        Horas Processados
      </Text>
      <Text variant="label" size="xs" className="text-neutral-muted">
        <strong className="text-neutral-default font-medium">{totalHours}h</strong> no período
        informado
      </Text>

      <LineChart data={data} unit="horas" />
    </div>
  );
}
